const exportToCSV = (data, filename, convertData = true) => {
    const csvContent = convertData ? data.map(row => row.join(",")).join("\n") : data;
    const encodedUri = encodeURI("data:text/csv;charset=utf-8," + csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export default exportToCSV